import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Form, Message } from 'semantic-ui-react';
import _get from 'lodash/get';
import _startCase from 'lodash/startCase';
import { validateFormField, createFileObjects } from './UploadFileField.utils';
import { FormFieldFilePropType } from '../../../../../types/FormField.types';
import UploadCareWidget from '../../../../UploadCareWidget';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
var uploadCareKey = process.env.UPLOADCARE_PUB_KEY;
function UploadFileField(_ref) {
  var field = _ref.field;
  var _useContext = useContext(DynamicFormContext),
    componentConfigurationId = _useContext.componentConfigurationId,
    hideLabels = _useContext.hideLabels,
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    setFormErrors = _useContext.setFormErrors,
    clearFieldError = _useContext.clearFieldError,
    displayErrors = _useContext.displayErrors,
    formData = _useContext.formData,
    touched = _useContext.touched;
  var label = field.label,
    name = field.name,
    required = field.required,
    disabled = field.disabled,
    _field$settings = field.settings,
    settings = _field$settings === void 0 ? {} : _field$settings;
  function fileChangeHandler(files) {
    clearFieldError(name);
    onChange(null, {
      name: name,
      value: createFileObjects(files)
    });
    var error = validateFormField(field, files);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  function getFiles() {
    return _get(formData, name, []);
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    className: "upload-file",
    disabled: isFormDisabled || disabled,
    required: required,
    name: name
  }, !hideLabels && /*#__PURE__*/React.createElement("label", null, _startCase(label)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UploadCareWidget, _extends({
    name: name,
    id: componentConfigurationId,
    publicKey: uploadCareKey,
    onFileChange: fileChangeHandler,
    files: getFiles(),
    isReset: !touched
  }, settings))), displayErrors && formErrors[name] && /*#__PURE__*/React.createElement(Message, {
    negative: true,
    size: "mini"
  }, formErrors[name]));
}
export default UploadFileField;